export const bankName = "GONET BANQUIERS";

export const email = "support@gonetgroup.icu";

export const address = "Zurich, Switzerland";

export const currency = "EUR";

export const currencySymbol = "€";

export const countryCode = "CH";

export const locale = "de-CH";
